import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { CalendarSurfaceDefaultComponent } from 'owa-calendar-surface-core';
import { ColumnPastDayHighlight } from 'owa-calendar-surface-dategrid';
import type { OwaDate } from 'owa-datetime';

export interface DayGridAllDayColumnAdditionalPropsType {
    date: OwaDate;
    disableWorkingHours: boolean;
}

export default observer(function DayGridAllDayColumnComponent({
    className,
    style,
    children,
    handlers,
    additionalProps,
}: {
    className?: string;
    style?: React.CSSProperties;
    children?: React.ReactNode;
    handlers?: React.DOMAttributes<HTMLElement>;
    additionalProps: DayGridAllDayColumnAdditionalPropsType;
}) {
    const { date, disableWorkingHours } = additionalProps;

    return (
        <CalendarSurfaceDefaultComponent className={className} style={style} handlers={handlers}>
            {children}
            {!disableWorkingHours && <ColumnPastDayHighlight date={date} />}
        </CalendarSurfaceDefaultComponent>
    );
});
